// extracted by mini-css-extract-plugin
export default {"walkmeIn":"walkmeIn_a9372","fadeIn":"fadeIn_cec8a"};